var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"page--index mt-2",class:{
    'pa-0': _vm.$voicer.isDesktopOrTablet,
    'pb-5': _vm.$voicer.isDesktopOrTablet,
  },attrs:{"grid-list-md":""}},[_c('w-block',{attrs:{"name":"heading"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.pageOptions.filter)?_c('w-filters'):_vm._e()],1),_vm._v(" "),_c('w-voicy',{attrs:{"options":_vm.pageOptions,"load-more":_vm.handleLoadMoreContents}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }